/**
 * @function
 * @name setCompanyInfo
 * @description reducer for action.
 * @param {Object} state  - reducer state
 * @param {Object} action - action context
 * @return {object} Action context
 */

import { Fund } from 'api';
import { CapTable } from 'common/types/allocation';
import { CompanyInfo } from 'common/types/company/company';
import { ReducerAction, ReducerState } from 'common/types/reducers';

export const setCompanyInfo = (state: ReducerState, action: ReducerAction<{ companyInfo: Partial<CompanyInfo> }>) => {
  const nextCompanyInfo = action.companyInfo ?? {};

  if (Object.keys(nextCompanyInfo).length === 0) {
    return {
      ...state,
      companyInfo: {},
    };
  }

  return {
    ...state,
    companyInfo: {
      ...state.companyInfo,
      ...nextCompanyInfo,
    },
  };
};

export const setCapTableList = (state: ReducerState, action: ReducerAction<{ capTableList: CapTable[] }>) => ({
  ...state,
  ...action,
});

export const setFundList = (state: ReducerState, action: ReducerAction<{ fundList: Fund[] }>) => ({
  ...state,
  ...action,
});

export const setCompanyList = (state: ReducerState, action: ReducerAction<{ companyList: CompanyInfo[] }>) => ({
  ...state,
  ...action,
});
